<template>
	<div class="display-live z-index-99" id=displayLiveId :class="{'no-cursor': !isShowButtonRebuild, 'crosshair-cursor': isShowButtonRebuild}">
		<transition name="fade">
			<div v-if="isShowButtonRebuild && !isLimitAccess" @click="rebuildCache" class="floating-rebuild-cache-btn" v-tooltip="$t('Rebuild Cache')">
				<i class="material-icons mt-1 pt-1" :class="{'is-loading': cachedFinished, 'mt-2': cachedFinished}">refresh</i>
			</div>
		</transition>
		<div class="stream-display">
			<!-- <div v-if="isShowAlert" class="alert alert-danger alert-dismissible fade show" role="alert">
				This Display is linked to rundown : {{ rundownName }} - <strong>Please close this message, when you are about to go Live</strong>
			<button @click="closeAlert" type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			</div> -->
			<transition-group name="transition">
				<div v-for="item in visibleElements" :key="item.id" :style="{ zIndex:item.layer_index }">
					<div :class="{'disabled': item.type === 'composition'}">
						<stream-element
							v-show="item.is_hidden === 0"
							:style="{ zIndex:item.layer_index }"
							:muted="isMuted"
							:status="type"
							:item="item"
							:key="item.id"
							:delay="display.delay"
						></stream-element>
					</div>
				</div>
			</transition-group>
		</div>
		<!-- access limit -->
		<modal
            class="swap-modal"
            size="small-medium"
            @close="closeLimit"
			:hide-footer="true"
			v-if="isLimitAccess">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Display Access') }}</h5>
            </template>
            <template slot="body">
				<div class="text-center">
					<p class="material-icons-warning-limit text-center">warning</p>
					<h5 v-if="idNotFoundMessage !== 'Cant find the display, please contact support'" class="mb-4 mt-4 text-center text-white">{{ $t('Sorry, this Display has reached the limit to be accessed') }}</h5>
					<h5 v-else class="mb-4 mt-4 text-center text-white">{{ $t('This display is not active, no rundown assigned') }}</h5>
				</div>
			</template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
		<modal
            class="swap-modal"
            size="small-medium"
            @close="closeLimit"
			:hide-footer="true"
			v-if="isBlockedAccess">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Display Access') }}</h5>
            </template>
            <template slot="body">
				<div class="text-center">
					<p class="material-icons-warning-limit text-center">warning</p>
					<h5 class="mb-4 mt-4 text-center text-white">{{ $t('Sorry, resource has blocked by your network please change network or your browser') }}</h5>
				</div>
			</template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
		<!-- display logo if there is no item -->
		<div v-if="visibleElements.length === 0 && isShowLogo" class="text-center center-image">
			<img :src="activeBg" alt="Grafias" width="70%">
		</div>
	</div>
</template>

<script>
import $ from 'jquery';
import { mapActions, mapGetters } from 'vuex';
import localforage from 'localforage';
import dayjs from 'dayjs';
import Modal from '@/components/Modal.vue';
import {
	getAxiosErrorMessage,
	getVideoBlob,
	getJSON,
	duplicateVar,
	delay,
} from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import rundownsApi from '@/api/rundowns';

// import displaysApi from '@/api/displays';
import displayApi from '@/api/displays';
import StreamElement from '@/components/StreamElement.vue';

export default {
	name: 'DisplayLive',
	components: {
		StreamElement,
		Modal,
	},
	props: {
		type: {
			type: String,
			default: 'live',
		},
	},
	sockets: {
		connect() {
			this.activateSocket();
		},
		item_update(item) {
			this.insertItem(item);
		},
		item_delete(id) {
			if (id) this.removeItem(parseInt(id));
		},
		item_bulk_delete(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.removeItem(item);
			}
		},
		// eslint-disable-next-line no-unused-vars
		remove_displays(items) {
			// when display removed stop all item
			this.onStopAll(items);
		},
		activate_display(display) {
			if (this.display) {
				this.changeBackgroundColor(display.background_color);
				if (this.display.id === display.id) {
					this.display = display;
					this.deactivateSocket();
					this.rundown = this.display && this.display.rundown ? this.display.rundown : null;
					this.fetchItems();
					if (this.display && !this.display.is_transparent_background) {
						if (this.display.user && this.display.background_color) {
							const settings = this.display.background_color;
							$('html.md-theme-default').css('background-color', settings || 'transparent');
						}
					} else {
						$('html.md-theme-default').css('background-color', 'transparent');
					}
				}
			} else {
				this.rundown = null;
			}
		},
		deactive_display(display) {
			if (this.display) {
				this.changeBackgroundColor(display.background_color);
				if (this.display.id === display.id) {
					this.onStopAll();
					this.display = display;
					this.deactivateSocket();
					this.rundown = this.display && this.display.rundown ? this.display.rundown : null;
					if (this.display && !this.display.is_transparent_background) {
						if (this.display.user && this.display.background_color) {
							const settings = this.display.background_color;
							$('html.md-theme-default').css('background-color', settings || 'transparent');
						}
					} else {
						$('html.md-theme-default').css('background-color', 'transparent');
					}
				}
			}
		},
		update_display(display) {
			if (this.display) {
				this.changeBackgroundColor(display.background_color);
				if (this.display.id === display.id) {
					Object.assign(this.display, display);
					this.rundown = this.display && this.display.rundown ? this.display.rundown : null;
					if (this.display && !this.display.is_transparent_background) {
						if (this.display && this.display.background_color) {
						// fillkey condition
							if (this.display.background_color !== 'fillkey') {
								const settings = this.display.background_color;
								$('html.md-theme-default').css('background-color', settings || 'transparent');
								$('.main, main').css('filter', '');
							} else {
								$('html.md-theme-default').css('background-color', '#000000');
								$('.main, main').css('filter', 'brightness(0) invert(1)');
							}
						}
					} else {
						$('html.md-theme-default').css('background-color', 'transparent');
						$('.main, main').css('filter', '');
					}
				}
			}
		},
		update_displays(displays) {
			for (let index = 0; index < displays.length; index++) {
				const display = displays[index];
				if (this.display) {
					if (this.display.id === display.id) {
						Object.assign(this.display, display);
						this.rundown = this.display && this.display.rundown ? this.display.rundown : null;
						if (this.display && !this.display.is_transparent_background) {
							if (this.display && this.display.background_color) {
							// fillkey condition
								if (this.display.background_color !== 'fillkey') {
									const settings = this.display.background_color;
									$('html.md-theme-default').css('background-color', settings || 'transparent');
									$('.main, main').css('filter', '');
								} else {
									$('html.md-theme-default').css('background-color', '#000000');
									$('.main, main').css('filter', 'brightness(0) invert(1)');
								}
							}
						} else {
							$('html.md-theme-default').css('background-color', 'transparent');
							$('.main, main').css('filter', '');
						}
					}
				}
			}
		},
		item_live_update(item) {
			this.insertItem(item);
		},
		async items_live_update(items) {
			await this.sleep(this.display && this.display.delay ? this.display.delay : 0);
			const filteredStartItems = items.filter(item => item.is_play_live || ((item.is_play_live && item.is_update_live && item.type === 'lower_third')));
			const filteredStopItems = items.filter(item => !item.is_play_live || ((item.is_play_live && !item.is_update_live && item.type === 'lower_third')));
			const lastItem = items && items.length > 0 ? duplicateVar(items[items.length - 1]) : null;
			const ultimateParent = lastItem && lastItem.isUltimateParent ? lastItem : null;
			if (filteredStartItems > 1 && ultimateParent) filteredStartItems.pop();

			const sortedStartItems = filteredStartItems.sort((a, b) => {
				const parsedA = JSON.parse(a.content);
				const parsedB = JSON.parse(b.content);
				return (parsedA.childOrder < parsedB.childOrder) ? -1 : 1;
			});
			for (let index = 0; index < filteredStopItems.length; index++) {
				const item = filteredStopItems[index];
				// find updated audio for fadeout
				const indexVisibleElement = this.visibleElements.findIndex(({ id }) => id === item.id);
				const idAudio = item.type === 'audio' && !item.is_play_live && this.visibleElements && this.visibleElements[indexVisibleElement] && this.visibleElements[indexVisibleElement].id;
				// insert item update
				this.insertItem(item, true, idAudio);
			}
			if (sortedStartItems.length > 0) {
				this.waitAndPlay(sortedStartItems, 0, lastItem);
			}
		},
		rundown_stop(items) {
			this.onStopAll(items);
		},
		rundown_live_stop(items) {
			this.onStopAllLive(items);
		},
		start_cache_display(data) {
			const items = data.items;
			this.startCache(items);
		},
		item_cache_display(data) {
			const items = data.items;
			this.startCacheItem(items);
		},
		item_mute_update(status) {
			this.muted = status;
		},
		rundown_update() {
			const isReset = true;
			this.fetch(isReset);
		},
	},
	data() {
		return {
			display: {},
			rundown: {},
			items: [],
			totalCached: 0,
			isShowAlert: false,
			muted: false,
			isShowButtonRebuild: false,
			timer: null,
			cachedFinished: false,
			clientIp: '',
			isLimitAccess: false,
			isBlockedAccess: false,
			idNotFoundMessage: '',
			i: 0,
			timeOut: null,
			backgroundColor: '#000000',
			whiteTransparentBg: '/img/logo/Grafias_FULLHD_White_transparent.png',
			darkTransparentBg: '/img/logo/Grafias_FULLHD_DARK_transparent.png',
			activeBg: '',
		};
	},
	created() {
		this.isShowAlert = true;
		this.$nextTick(() => {
			$('body').css('background-color', 'transparent');
			$('html.md-theme-default').css('background-color', 'transparent');
			$(document).find('main').removeClass('main');
			$('html').css('overflow', 'hidden');
			this.setNavbarVisible(false);
			this.setDrawerVisible(false);
		});
		this.activateSocket();
		this.fetch();
	},
	mounted() {
		// window.addEventListener('resize', this.onResize);
		// this.onResize();
		const element = document.getElementById('displayLiveId');
		element.addEventListener('mousemove', () => {
			this.isShowButtonRebuild = true;
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.isShowButtonRebuild = false;
			}, 1000);
		});
		element.addEventListener('mouseleave', () => {
			clearTimeout(this.timer);
			this.isShowButtonRebuild = false;
		});
		// fetch('https://api.ipify.org?format=json')
		// 	.then(response => response.json())
		// 	// eslint-disable-next-line
		// 	.then(response => {
		// 		this.clientIp = response.ip;
		// 		this.fetch();
		// 	})
		// 	.catch(() => {
		// 		this.isBlockedAccess = true;
		// 	});
	},
	destroyed() {

	},
	beforeDestroy() {
		this.$nextTick(() => {
			$(document).find('main').addClass('main');
			$('body').css('background-color', '');
			$('html.md-theme-default').css('background-color', '');
			$('html').css('overflow', 'visible');
			$('.main, main').css('filter', '');
			this.setNavbarVisible(true);
			this.setDrawerVisible(true);
		});
	},
	methods: {
		sleep(ms) {
			return new Promise(
				resolve => setTimeout(resolve, ms),
			);
		},
		...mapActions({
			setNavbarVisible: 'setNavbarVisible',
			setDrawerVisible: 'setDrawerVisible',
		}),
		waitAndPlay(items, i, lastItem) {
			const item = items && items.length > 0 ? items[i] : null;
			const nextItem = items && items.length > 0 && i < items.length - 1 ? items[i + 1] : null;
			if (item) this.insertItem(item);
			const itemContent = item && item.content ? item.content : '{}';
			const contentSortedStartItem = JSON.parse(itemContent);
			const childDuration = contentSortedStartItem && contentSortedStartItem.childOrder ? contentSortedStartItem.childOrder : 0;
			const ultimateParent = lastItem && lastItem.isUltimateParent ? lastItem : null;
			const ultimateParentContent = ultimateParent ? JSON.parse(ultimateParent.content) : null;
			const itemLength = items.length;
			const ultimateParentDuration = ultimateParentContent && ultimateParentContent.childOrder ? ultimateParentContent.childOrder : 0;
			let duration = childDuration < 0 ? (childDuration * -1) : childDuration;

			if (ultimateParent && item.id === ultimateParent.id) {
				if (nextItem) {
					const nextItemContent = nextItem && nextItem.content ? JSON.parse(nextItem.content) : '{}';
					const nextChildDuration = nextItemContent && nextItemContent.childOrder ? nextItemContent.childOrder : 0;
					if (nextChildDuration > ultimateParentDuration) {
						duration = nextChildDuration < 0 ? (nextChildDuration * -1) : nextChildDuration;
					}
				}
			}
			if (nextItem) {
				const nextItemContent = nextItem && nextItem.content ? JSON.parse(nextItem.content) : '{}';
				const nextChildDuration = nextItemContent && nextItemContent.childOrder ? nextItemContent.childOrder : 0;
				if (nextChildDuration === childDuration) {
					this.insertItem(nextItem);
					duration = 0;
				} else {
					// eslint-disable-next-line no-lonely-if
					if (childDuration > ultimateParentDuration) {
						duration = nextChildDuration < 0 ? (nextChildDuration * -1) : nextChildDuration;
					}
				}
			}
			const timeOut = setTimeout(() => { //  call a 3s setTimeout when the loop is called
				let indexInterval = i + 1;
				if (indexInterval < itemLength) { //  if the counter < 10, call the loop function
					this.waitAndPlay(items, indexInterval, lastItem); //  ..  again which will trigger another
				} //  ..  setTimeout()
				if (indexInterval === itemLength) {
					clearTimeout(timeOut);
					indexInterval = 0;
				}
			}, duration);
		},
		rebuildCache() {
			this.startCache(this.items);
		},
		closeAlert() {
			this.isShowAlert = false;
		},
		startCache(items) {
			const medias = items.filter(item => ((item.type === 'image' || item.type === 'video' || item.type === 'lottie' || item.type === 'lower_third')));
			// Cache
			medias.forEach(async (item, index) => {
				let itemKey = `media_${item.id}`;
				let content = item.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}

				if ((item.type === 'image' || item.type === 'video') && content && content.id) itemKey = `media_${content.id}`;
				if (item.type === 'lottie' && content && content.id) itemKey = `lottie_media_${content.id}`;
				if (item.type === 'lower_third' && content && content.template && content.template.id) itemKey = `lottie_lt_${content.template.id}`;

				localforage.getItem(itemKey, async (value) => {
					if (!value) {
						const mediaContent = item && item.content ? JSON.parse(item.content) : null;
						const itemMediaPath = mediaContent && mediaContent.url ? mediaContent.url : null;
						const url = mediaContent && mediaContent.template && mediaContent.template.file_path ? mediaContent.template.file_path : null;
						if (itemMediaPath && (item.type === 'image' || item.type === 'video')) {
							await this.cacheFile(itemKey, itemMediaPath, index + 1);
						} else if (itemMediaPath && item.type === 'lottie') {
							await this.cacheLowerThird(itemKey, itemMediaPath, index + 1);
						} else if (url && item.type === 'lower_third') {
							await this.cacheLowerThird(itemKey, url, index + 1);
						}
					}
				});
			});
		},
		startCacheItem(items) {
			const medias = items.filter(item => ((item.type === 'image' || item.type === 'video' || item.type === 'lottie' || item.type === 'lower_third')));
			medias.forEach(async (item, index) => {
				let itemKey = `media_${item.id}`;
				let content = item.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}

				if ((item.type === 'image' || item.type === 'video') && content && content.id) itemKey = `media_${content.id}`;
				if (item.type === 'lottie' && content && content.id) itemKey = `lottie_media_${content.id}`;
				if (item.type === 'lower_third' && content && content.template && content.template.id) itemKey = `lottie_lt_${content.template.id}`;

				localforage.getItem(itemKey, async (value) => {
					if (!value) {
						const mediaContent = item && item.content ? JSON.parse(item.content) : null;
						const itemMediaPath = mediaContent && mediaContent.url ? mediaContent.url : null;
						const url = mediaContent && mediaContent.template && mediaContent.template.file_path ? mediaContent.template.file_path : null;
						if (itemMediaPath && (item.type === 'image' || item.type === 'video')) {
							await this.cacheRundownItemFile(itemKey, itemMediaPath, index + 1, item);
						} else if (itemMediaPath && item.type === 'lottie') {
							await this.cacheRundownItemLowerThird(itemKey, itemMediaPath, index + 1, item);
						} else if (url && item.type === 'lower_third') {
							await this.cacheRundownItemLowerThird(itemKey, url, index + 1, item);
						}
					}
				});
			});
		},

		cacheRundownItemLowerThird(lottieKey, url, index, item) {
			// get media assets as blob....
			this.cachedFinished = true;
			let promise;
			try {
				promise = new Promise((resolve, reject) => {
					getJSON(url).then((blob) => {
					// Check videoBlob
						if (!blob) return;
						// Set key and blob
						localforage.getItem(lottieKey).then((value) => {
							if (value) {
								localforage.setItem(lottieKey, blob, (err, saveValue) => {
									if (!err && saveValue) {
										this.cacheRundownItemDisplays(index, item);
										resolve(index);
									} else {
										reject(new Error('Error When Downloading Lottie or Lower third not found'));
									}
								});
								this.cachedFinished = false;
							}
						}).catch((e) => {
							console.log(e);
						});
					}).catch(() => {
						reject(new Error('something went wrong in network when get media'));
						this.cachedFinished = false;
					});
				});
				return promise;
			} catch (err) {
				this.cachedFinished = false;
			}
			return promise;
		},
		cacheRundownItemFile(mediaKey, itemMediaPath, index, item) {
			// get media assets as blob....
			this.cachedFinished = true;
			let promise;
			try {
				promise = new Promise((resolve, reject) => {
					getVideoBlob(itemMediaPath).then((blob) => {
					// Check videoBlob
						if (!blob) return;
						// Set key and blob
						localforage.getItem(mediaKey).then((value) => {
							if (value) {
								localforage.setItem(mediaKey, blob, (err, value) => {
									if (!err && value) {
										this.cacheRundownItemDisplays(index, item);
										resolve(index);
									} else {
										reject(new Error('Error When Downloading Video or Media not found'));
									}
								});
								this.cachedFinished = false;
							}
						}).catch((e) => {
							console.log(e);
						});
					}).catch(() => {
						this.cachedFinished = false;
					});
				});
				return promise;
			} catch (err) {
				this.cachedFinished = false;
			}
			return promise;
		},
		cacheLowerThird(lottieKey, url, index) {
			// get media assets as blob....
			this.cachedFinished = true;
			let promise;
			try {
				promise = new Promise((resolve, reject) => {
					getJSON(url).then((blob) => {
					// Check videoBlob
						if (!blob) return;
						// Set key and blob
						localforage.setItem(lottieKey, blob, (err, value) => {
							if (!err && value) {
								this.cacheDisplays(index);
								resolve(index);
							} else {
								reject(new Error('Error When Downloading Lottie or Lower third not found'));
							}
						});
						this.cachedFinished = false;
					}).catch(() => {
						reject(new Error('something went wrong in network when get media'));
						this.cachedFinished = false;
					});
				});
				return promise;
			} catch (err) {
				this.cachedFinished = false;
			}
			return promise;
		},
		cacheFile(mediaKey, itemMediaPath, index) {
			// get media assets as blob....
			this.cachedFinished = true;
			let promise;
			try {
				promise = new Promise((resolve, reject) => {
					getVideoBlob(itemMediaPath).then((blob) => {
					// Check videoBlob
						if (!blob) return;
						// Set key and blob
						localforage.setItem(mediaKey, blob, (err, value) => {
							if (!err && value) {
								this.cacheDisplays(index);
								resolve(index);
							} else {
								reject(new Error('Error When Downloading Video or Media not found'));
							}
						});
						this.cachedFinished = false;
					}).catch(() => {
						this.cachedFinished = false;
					});
				});
				return promise;
			} catch (err) {
				this.cachedFinished = false;
			}
			return promise;
		},
		cacheDisplays(count) {
			const callback = () => {
			};
			const callbackError = () => {
			};
			const params = {
				display_name: this.displayName,
				display_id: this.displayId,
				count,
			};
			rundownsApi.cacheDisplay(this.rundown.id, params, callback, callbackError);
		},
		cacheRundownItemDisplays(count, item) {
			const callback = () => {
			};
			const callbackError = () => {
			};
			const params = {
				display_name: item.name || 'Rundown Asset',
				display_id: this.displayId,
				count,
			};
			rundownItemsApi.cacheDisplay(item.id, params, callback, callbackError);
		},
		activateSocket() {
			this.$socket.client.emit('join', this.room);
		},
		deactivateSocket() {
			this.$socket.client.emit('leave', this.room);
		},
		removeElement(item) {
			const element = document.getElementById(`${item.type}-${item.id}`);
			if (element) {
				element.remove();
			}
		},
		removeItem(itemId) {
			const index = this.items.findIndex(({ id }) => id === itemId);
			if (index !== -1) {
				this.items.splice(index, 1);
			}
		},
		insertItem(item, reset = false, fadeoutAudioId) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			} else {
				const currentItemUpdatedDate = dayjs(this.items[index].updated_at);
				const newItemUpdatedDate = dayjs(item.updated_at);
				const isItemNewer = newItemUpdatedDate.isAfter(currentItemUpdatedDate);
				// eslint-disable-next-line no-lonely-if
				if (isItemNewer || reset) {
					// for non audio type assets
					if (!fadeoutAudioId) this.$set(this.items, index, item);
					// for audio type assets
					if (fadeoutAudioId) {
						delay(() => {
							this.$set(this.items, index, item);
						}, 1000);
					}
				}
			}
		},
		onStartPlay(item) {
			this.insertItem(item);
		},
		initSocket(display) {
			const displayId = display && display.id ? display.id : '';
			const rundownId = display && display.rundown && display.rundown.id ? display.rundown.id : '';
			const payload = {
				display_id: displayId,
				rundown_id: rundownId,
			};
			// Join Room
			this.$socket.client.emit('set_display_access', payload);
		},
		// getting rundown inside display first
		fetch(isReset) {
			this.isLimitAccess = false;
			const id = this.id;
			const callback = (response) => {
				const display = response.data;
				this.display = display || null;
				this.rundown = display && display.rundown ? display.rundown : null;
				if (!isReset) this.initSocket(display);
				if (this.display && !this.display.is_transparent_background) {
					if (this.display && this.display.background_color) {
						// fillkey condition
						if (this.display.background_color !== 'fillkey') {
							const settings = this.display.background_color;
							$('html.md-theme-default').css('background-color', settings || 'transparent');
							$('.main, main').css('filter', '');
						} else {
							$('html.md-theme-default').css('background-color', '#000000');
							$('.main, main').css('filter', 'brightness(0) invert(1)');
						}
					}
				} else {
					$('html.md-theme-default').css('background-color', 'transparent');
					$('.main, main').css('filter', '');
				}
				if (this.rundown) {
					this.fetchItems();
				}
				// if (this.display && this.display.rundown) {
				// }
				// this.fetchItems();
				// init color bg image
				if (display.background_color === 'background:none' || display.background_color === '#00FF00') {
					this.activeBg = this.darkTransparentBg;
					return this.activeBg;
				}
				this.activeBg = this.whiteTransparentBg;
				return this.activeBg;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.idNotFoundMessage = message;
				this.isLimitAccess = true;
			};
			const rundownId = this.$route.query.rundown_id ? this.$route.query.rundown_id : '';
			const params = {
				rundown_id: rundownId,
			};
			displayApi.get(id, params, callback, errorCallback);
		},
		fetchItems() {
			const rundownId = this.rundown.id;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'created_at',
				sort_by: 'desc',
				rundown_id: rundownId,
			};

			const callback = (response) => {
				const items = response.data;
				this.items = items;
				this.items.forEach((item) => {
					this.onStartPlay(item);
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'display Items',
					text: message,
				});
			};
			rundownItemsApi.getList(params, callback, errorCallback);
		},
		onStopAll(items) {
			for (let index = 0; index < items.length; index++) {
				const tmpItem = this.items.find(item => item.id === items[index].id);
				if (tmpItem && !tmpItem.is_locked) {
					tmpItem.is_play_live = 0;
					tmpItem.is_play_preview = 0;
				}
			}
		},
		onStopAllLive(items) {
			for (let index = 0; index < items.length; index++) {
				const tmpItem = this.items.find(item => item.id === items[index].id);
				if (tmpItem && !tmpItem.is_locked) {
					tmpItem.is_play_live = 0;
				}
			}
		},
		closeLimit() {
			this.$router.push('/');
		},
		changeBackgroundColor(color) {
			if (color === 'background:none' || color === '#00FF00') {
				this.activeBg = this.darkTransparentBg;
				return this.activeBg;
			}
			this.activeBg = this.whiteTransparentBg;
			return this.activeBg;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		slug() {
			return this.$route.params.displaySlug;
		},
		isMuted() {
			return this.muted;
		},
		id() {
			return this.$route.params.id;
		},
		room() {
			let room = `rundown_${this.slug}`;
			if (this.rundown) {
				const rundownSlug = this.rundown.slug;
				room = `rundown_${rundownSlug}`;
			}
			return room;
		},
		rundownName() {
			return this.rundown && this.rundown.name ? this.rundown.name : '';
		},
		displayName() {
			return this.display && this.display.name ? this.display.name : '';
		},
		displayId() {
			return this.display && this.display.id ? this.display.id : '';
		},
		visibleElements() {
			let filter = item => (item.is_play_live === 1);
			const layerIndex = typeof this.display.layer_index === 'string' ? JSON.parse(this.display.layer_index) : [];
			if (Array.isArray(layerIndex) && layerIndex.length && !layerIndex.includes('0')) {
				filter = item => (item.is_play_live === 1 && layerIndex.includes(item.layer_index ? item.layer_index.toString() : ''));
			} else {
				filter = item => (item.is_play_live === 1);
			}
			const filteredItems = this.items.filter(filter);
			return filteredItems;
		},
		isShowLogo() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			const settingsShowLogo = settings && settings.is_enable_show_logo ? settings.is_enable_show_logo : false;
			return settingsShowLogo;
		},
	},
	watch: {
		rundown() {
			this.activateSocket();
		},
	},
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>
